import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {

    // 查询列表数据
    findAll({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`campusPerformance/page`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
  expotrtTable({ commit }, params) {
        return new Promise((resolve, reject) => {
          axios({
            method: 'post',
            url: '/campusPerformance/campusPerformanceExport',
            data: params,
            responseType: 'blob',
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        })
  },

};
